import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import { huddleTodayForecastHasData } from '@utils/dashboardHuddle.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import type { HuddleDashboard } from '../useHuddleDashboard'
import { HuddleMetricGrid } from '../HuddleMetricGrid.component'

type TodaysForecastCardProps = {
  titleHref: string
  forecast: HuddleDashboard['todayForecastApi']
  className?: string
}

export function TodaysForecastCard({
  titleHref,
  forecast,
  className = 'dashboard-huddle-forecast-card',
}: TodaysForecastCardProps): React.ReactElement {
  const { summaryMetrics, loading, data } = forecast
  const isEmpty = shouldShowDashboardSectionEmpty(
    loading,
    huddleTodayForecastHasData(data),
  )
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Today's forecast"
      titleHref={titleHref}
      className={className}
      loading={pending}
      skeleton={{ metrics: 4 }}
      isEmpty={isEmpty}
    >
      <HuddleMetricGrid metrics={summaryMetrics} />
    </DashboardSectionCard>
  )
}
